// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"card-image-type-2-wo-image-m__wrapper__2b-8e"};